module.exports = __webpack_public_path__ + "img/default-img.6cf35fed.png";